const Resources = ($) => {
	$('.download-all-resources').on('click', function (e) {
		e.preventDefault();

		const selectedFiles = [];
		$('.resource-checkbox:checked').each(function () {
			const url = $(this).data('file-url');
			if (url) {
				selectedFiles.push(url);
			}
		});

		if (selectedFiles.length === 0) {
			alert('Please select at least one resource to download.');
			return;
		}

		selectedFiles.forEach((url, index) => {
			setTimeout(() => {
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '');
				link.target = '_blank';
				document.body.appendChild(link);
				link.click();
				link.remove();
			}, index * 500); // Small delay to prevent browser blocking multiple downloads
		});
	});
}

export default (($) => $(Resources))(jQuery)
